import React, { useEffect, useRef } from "react";
import { dropTargetForElements } from "@atlaskit/pragmatic-drag-and-drop/element/adapter";
import AtlassianBlockCard from "./cards/BlockCard";

const BlockDropZone = ({
  blocks,
  onReorder,
  onBlockClick,
  isEditMode = false,
  sectionIdx,
  sections,
  setSections,
  handleInsertBlock,
  handleDeleteBlock,
}) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!isEditMode) return;

    const element = ref.current;
    if (!element) return;

    return dropTargetForElements({
      element,
      canDrop: ({ source }) => source.data.type === "block-card",
      onDrop: ({ source, location }) => {
        console.log("Dropped block in zone:", source.data);
      },
    });
  }, [isEditMode]);

  const moveBlock = (dragIndex, hoverIndex) => {
    if (!isEditMode) return;

    const draggedBlock = blocks[dragIndex];
    const newBlocks = [...blocks];

    newBlocks.splice(dragIndex, 1);
    newBlocks.splice(hoverIndex, 0, draggedBlock);

    const updated = [...sections];
    updated[sectionIdx].blocks = newBlocks;
    setSections(updated);

    if (onReorder) {
      onReorder(newBlocks);
    }
  };

  return (
    <div
      ref={ref}
      className={`block-drop-zone ${isEditMode ? "edit-mode" : ""}`}
    >
      {blocks.map((block, index) => (
        <AtlassianBlockCard
          key={block.id || index}
          block={block}
          index={index}
          sectionIdx={sectionIdx}
          blockIdx={index}
          sections={sections}
          setSections={setSections}
          isEditing={isEditMode}
          onClick={() => onBlockClick && onBlockClick(block)}
          moveBlock={moveBlock}
          totalItems={blocks.length}
          handleInsertBlock={handleInsertBlock}
          handleDeleteBlock={handleDeleteBlock}
        />
      ))}
    </div>
  );
};

export default BlockDropZone;
